import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=dc9a3e82&scoped=true&"
import script from "./orderlist.vue?vue&type=script&lang=js&"
export * from "./orderlist.vue?vue&type=script&lang=js&"
import style1 from "./orderlist.vue?vue&type=style&index=1&id=dc9a3e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9a3e82",
  null
  
)

export default component.exports